import styled from "styled-components";

export const OfferWrap = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledDescription = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 24px;
  margin-bottom: 10px;
`;
